module.exports = __webpack_public_path__ + "static/media/not_found_icon.cc0060cb.svg";